Object.defineProperty(exports,"__esModule",{value:true});exports.getFixtureArmState=undefined;

var _types=require('./types');

var _armStateUtils=require('./armStateUtils');
var _securityDeviceArmState=require('./securityDeviceArmState');

var getFixtureArmState=exports.getFixtureArmState=function getFixtureArmState(fixture){
if(!fixture){
return null;
}

var hasArmedOrLocked=false;
var hasDisarmedOrUnlocked=false;
var hasOther=false;

var positionArmStates=fixture.positionIds.
toModelArray().
map(function(position){
var device=position.getArmDevice();
return(0,_securityDeviceArmState.getSecurityDeviceArmState)(device);
}).
filter(function(s){return s!==null;});

if(positionArmStates&&positionArmStates.length===0){
return{type:_types.armState.FIXTURE_EMPTY};
}

var containsAlarmingPosition=positionArmStates.reduce(
function(contains,pState){return contains||pState.type===_types.armState.ALARMING;},
false);

if(containsAlarmingPosition){
return{type:_types.armState.ALARMING};
}

for(var _iterator=positionArmStates,_isArray=Array.isArray(_iterator),_i=0,_iterator=_isArray?_iterator:_iterator[typeof Symbol==='function'?Symbol.iterator:'@@iterator']();;){var _ref;if(_isArray){if(_i>=_iterator.length)break;_ref=_iterator[_i++];}else{_i=_iterator.next();if(_i.done)break;_ref=_i.value;}var pArmState=_ref;var
posArmState=pArmState.type;

hasArmedOrLocked=
hasArmedOrLocked||
posArmState===_types.armState.ARMED||
posArmState===_types.armState.LOCKED;
hasDisarmedOrUnlocked=
hasDisarmedOrUnlocked||
posArmState===_types.armState.DISARMED||
posArmState===_types.armState.UNLOCKED;
hasOther=
!hasArmedOrLocked&&
!hasDisarmedOrUnlocked&&
posArmState!==_types.armState.MISSING_SECURITY_DEVICE;


if(hasArmedOrLocked&&(hasOther||hasDisarmedOrUnlocked)){
break;
}
}

var onlyContainsLocks=fixture.onlyContainsLocks();

if(hasArmedOrLocked){
if(hasDisarmedOrUnlocked||hasOther){
return onlyContainsLocks?
{type:_types.armState.PARTIALLY_LOCKED}:
{type:_types.armState.PARTIALLY_ARMED};
}
return onlyContainsLocks?
{type:_types.armState.LOCKED}:
{type:_types.armState.ARMED};
}else if(hasDisarmedOrUnlocked){
return onlyContainsLocks?
worstUnlockedArmState(positionArmStates):
{type:_types.armState.DISARMED};
}else if(hasOther){
return{type:_types.armState.OTHER_STATE};
}else if(positionArmStates.length>0){
return{type:_types.armState.MISSING_SECURITY_DEVICE};
}else{
return{type:_types.armState.FIXTURE_EMPTY};
}
};



var worstUnlockedArmState=function worstUnlockedArmState(positionArmStates){
var startState={
type:_types.armState.UNLOCKED,
payload:{text:'0',warning:false}};

return positionArmStates.reduce(function(worstSoFar,armState){
var magic={
type:armState.UNLOCKED,
payload:{text:'',warning:false}};

if(armState===magic){
if((0,_armStateUtils.isWorseThan)(worstSoFar,armState)){
return armState;
}
}

return worstSoFar;
},startState);
};